/**
 * builds a AbortController that will be canceled after the given timeout
 *
 * @param timeout the timeout in seconds
 * @return the AbortController (if the timeout is positive) and a clearTimeout callback
 */
export function buildTimeoutAbortController(
    timeout: number | undefined
): [AbortController | undefined, () => void] {
    if (!timeout || timeout < 0) {
        // timeout must be positive
        return [undefined, () => {}];
    }
    const abortController = new AbortController();
    const timeoutId = setTimeout(() => {
        abortController.abort(
            new DOMException('response timed out', 'TimeoutError')
        );
    }, timeout * 1000);

    return [
        abortController,
        () => {
            clearTimeout(timeoutId);
        },
    ];
}
